/**
 * Housecall Pro Integration API Client
 */
import api from './api';

export const housecallProAPI = {
  // Connection
  getStatus: () => api.get('/integrations/housecall-pro/'),
  connect: (data) => api.post('/integrations/housecall-pro/connect', data),
  testConnection: () => api.post('/integrations/housecall-pro/test'),
  disconnect: () => api.post('/integrations/housecall-pro/disconnect'),
  updateSettings: (data) => api.patch('/integrations/housecall-pro/settings', data),

  // Import & Sync
  runImport: (data) => api.post('/integrations/housecall-pro/import', data),
  getImportStatus: (taskId) => api.get(`/integrations/housecall-pro/import/status/${taskId}`),
  syncDomain: (domain) => api.post('/integrations/housecall-pro/sync', { domain }),

  // Logs
  getLogs: (params = {}) => api.get('/integrations/housecall-pro/logs', { params }),

  // Mappings
  getMappingSummary: () => api.get('/integrations/housecall-pro/mappings/summary'),
  getMappings: (params = {}) => api.get('/integrations/housecall-pro/mappings', { params }),
  updateMapping: (id, data) => api.patch(`/integrations/housecall-pro/mappings/${id}`, data),
};

export default housecallProAPI;
